import APIService from '../../../../Services/APIService';
import { Apis } from '../../../../Services/app.constants';

const query = (params) =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
    .join('&');

export const statusWorkflowService = {
  fetchStatuses({ leadFormId, active = '', typeOfStatus = '' } = {}) {
    if (!leadFormId) throw new Error('Lead form ID is required');
    return APIService.get(
      `${Apis.statusSubStatus}?${query({
        leads_form_id: leadFormId,
        active: active?.value ?? active,
        type_of_status: typeOfStatus,
      })}`
    );
  },

  listStatuses(filters) {
    return this.fetchStatuses(filters);
  },

  async getStatus({ statusId, ...filters } = {}) {
    const response = await this.fetchStatuses(filters);
    const statuses = Array.isArray(response?.data) ? response.data : [];
    return {
      ...response,
      data: statuses.find(
        (item) =>
          String(item?.status_id ?? item?.id ?? item?.statusId) === String(statusId)
      ),
    };
  },

  saveStatus(payload) {
    return APIService.post(Apis.statusSubStatus, payload);
  },

  deleteStatus(statusId) {
    if (!statusId) throw new Error('Status ID is required');
    return APIService.remove(
      `${Apis.statusSubStatus}?status_id=${encodeURIComponent(statusId)}`
    );
  },

  reorderStatuses(payload) {
    return APIService.post('/v0/ui/leads/update-sort-web-formstatus/', payload);
  },

  fetchAssignedUsers({ organisationId, campaignId = '' } = {}) {
    if (!organisationId) throw new Error('Organisation ID is required');
    return APIService.get(
      `${Apis.getUserMinimalList}?${query({
        org_id: organisationId,
        campaign_id: campaignId,
      })}`
    );
  },

  listAssignedUsers(organisationId, campaignId = '') {
    return this.fetchAssignedUsers({ organisationId, campaignId });
  },
};

export default statusWorkflowService;
